import {FC} from 'react';

type Icon = {
    className?: string;
};

const AmplifyLogoSmall: FC<Icon> = ({className}) => (
    <svg
        width="30"
        height="29"
        viewBox="0 0 35 34"
        fill="none"
        style={{marginLeft: '2px'}}
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path d="M0 22.666h11.412V34L0 22.666Z" fill="#e8edec" />
        <path d="m0 11.334 8.559 8.5h5.706V25.5l8.559 8.5V11.334H0Z" fill="#e8edec" />
        <path d="m0 0 8.559 8.5h17.117v17l8.56 8.5V0H0Z" fill="#e8edec" />
    </svg>
);

export default AmplifyLogoSmall;
